import { lightColor, darkColor } from '../BaseTheme/Colors';

const lightThemeIconButton = {
  styleOverrides: {
    root: {
      color: lightColor.black.main,
      '&:hover': {
        backgroundColor: lightColor.transparent.main,
        color: lightColor.black.main,
      },
    },
  },
};

const darkThemeIconButton = {
  styleOverrides: {
    root: {
      color: darkColor.white.main,
      '&:hover': {
        backgroundColor: darkColor.transparent.main,
        color: darkColor.white.main,
      },
    },
  },
};

export { lightThemeIconButton, darkThemeIconButton };
